import React from 'react';
import DownloadTable from './downloadTable';

const Main = () => {
  return (
    <>
      <DownloadTable />
    </>
  );
}

export default Main;